import { render } from "./ClientAlert.vue?vue&type=template&id=2c8d662a"
import script from "./ClientAlert.vue?vue&type=script&lang=js"
export * from "./ClientAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__